// extracted by mini-css-extract-plugin
module.exports = {"inputButton":"InputButton_inputButton__NRqY7","active":"InputButton_active__3jI2D"};